import { API_VACATION } from "../consts/apiRoutes.consts"
import SERVICE_CONSTS from "../consts/services.consts"
import { api } from "./base/api.service"

const { RESPONSE_BASIC_STRUCTURE, MESSAGES } = SERVICE_CONSTS

/** @type {import("./vacation.service.types")["getAdminVacationResume"]} */
export const getAdminVacationResume = async (year) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(`${API_VACATION}/getAdminVacationResume/${year}`)
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

/** @type {import("./vacation.service.types")["getAdminVacationResumeByMonth"]} */
export const getAdminVacationResumeByMonth = async (
  year,
  month,
  type = "totals"
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_VACATION}/getAdminVacationResumeByMonth/${year}/${month}/${type}`
    )

    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    console.error("Service fetch error:", error)
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS

  return response
}

/** @type {import("./vacation.service.types")["getYearHolidays"]} */
export const getYearHolidays = async (year) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(`${API_VACATION}/getYearHolidays/${year}`)
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

/** @type {import("./vacation.service.types")["getHolidaysOnDateRange"]} */
export const getHolidaysOnDateRange = async (startDate, endDate) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(`${API_VACATION}/getHolidaysOnDateRange`, {
      startDate,
      endDate,
    })
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const saveYearHolidays = async (year, holidays) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(`${API_VACATION}/saveYearHolidays/${year}`, {
      holidays,
    })
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

/** @type {import("./vacation.service.types")["getTeamVacationsRequestsByYear"]} */
export const getTeamVacationsRequestsByYear = async (year) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_VACATION}/getTeamVacationsRequestsByYear/${year}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

/** @type {import("./vacation.service.types")["getOldestYearWithVacations"]} */
export const getOldestYearWithVacations = async () => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(`${API_VACATION}/getOldestYearWithVacations`)
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getFutureFurthestYearWithVacations = async () => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(`${API_VACATION}/getFutureFurthestYearWithVacations`)
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const reviewPendingVacationRequest = async (
  vacationRequestId,
  vacationRangeId,
  approved,
  cancelationMotive
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(
      `${API_VACATION}/reviewPendingVacationRequest/${vacationRequestId}`,
      {
        vacationRangeId,
        approved,
        cancelationMotive,
      }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const updateApprovedVacationPlusDaysPayDate = async (
  vacationRequestId,
  plusDaysPayDate
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(
      `${API_VACATION}/updateApprovedVacationPlusDaysPayDate/${vacationRequestId}`,
      {
        plusDaysPayDate,
      }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const cancelApprovedVacationRequest = async (
  vacationRequestId,
  cancelationMotive
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(
      `${API_VACATION}/cancelApprovedVacationRequest/${vacationRequestId}`,
      {
        cancelationMotive,
      }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const rejectChangeVacationRequest = async (vacationRequestId) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.put(
      `${API_VACATION}/rejectChangeVacationRequest/${vacationRequestId}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const approveChangeVacationRequest = async (vacationRequestId) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.put(
      `${API_VACATION}/approveChangeVacationRequest/${vacationRequestId}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

/** @type {import("./vacation.service.types")["getTeamMemberVacationResume"]} */
export const getTeamMemberVacationResume = async (
  monthStartDate,
  monthEndDate,
  startDate,
  endDate
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(`${API_VACATION}/getTeamMemberVacationResume`, {
      monthStartDate,
      monthEndDate,
      startDate,
      endDate,
    })
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getTeamMemberVacationResumeExcludeVacationID = async (
  monthStartDate,
  monthEndDate,
  startDate,
  endDate,
  vacationId
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(
      `${API_VACATION}/getTeamMemberVacationResumeExcludeVacationID`,
      {
        monthStartDate,
        monthEndDate,
        startDate,
        endDate,
        vacationId,
      }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

/** @type {import("./vacation.service.types")["getTeamMemberBucketDaysAsOfToday"]} */
export const getTeamMemberBucketDaysAsOfToday = async (
  monthStartDate,
  monthEndDate
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(
      `${API_VACATION}/getTeamMemberBucketDaysAsOfToday`,
      {
        monthStartDate,
        monthEndDate,
      }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getTeamMemberBucketDaysResume = async (
  periodStartDate,
  periodEndDate,
  monthStartDate,
  monthEndDate
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(`${API_VACATION}/getTeamMemberBucketDaysResume`, {
      periodStartDate,
      periodEndDate,
      monthStartDate,
      monthEndDate,
    })
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

/** @type {import("./vacation.service.types")["getTeamMemberBucketDaysResumeExcludeVacationID"]} */
export const getTeamMemberBucketDaysResumeExcludeVacationID = async (
  periodStartDate,
  periodEndDate,
  monthStartDate,
  monthEndDate,
  vacationId,
  vacationStartDate
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(
      `${API_VACATION}/getTeamMemberBucketDaysResumeExcludeVacationID`,
      {
        periodStartDate,
        periodEndDate,
        monthStartDate,
        monthEndDate,
        vacationId,
        vacationStartDate,
      }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

/** @type {import("./vacation.service.types")["getTeamMemberTypesDayOff"]} */
export const getTeamMemberTypesDayOff = async () => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(`${API_VACATION}/getTypesOfDayOffForTeamMember`)
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

/** @type {import("./vacation.service.types")["getTeamMemberTypeDayOffInfo"]} */
export const getTeamMemberTypeDayOffInfo = async (startDate, endDate) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(`${API_VACATION}/getTeamMemberTypeDayOffInfo`, {
      startDate,
      endDate,
    })
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getTeamMemberVacationRequests = async (startDate, endDate) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(
      `${API_VACATION}/getTeamMemberVacationsRequestsByYear`,
      {
        startDate,
        endDate,
      }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

/** @type {import("./vacation.service.types")["getTeamMemberVacationDayOffsInRange"]} */
export const getTeamMemberVacationDayOffsInRange = async (
  startDate,
  endDate
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(
      `${API_VACATION}/getTeamMemberVacationDayOffsInRange`,
      {
        startDate,
        endDate,
      }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const rejectCancelVacationRequest = async (vacationRequestId) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.put(
      `${API_VACATION}/rejectCancelVacationRequest/${vacationRequestId}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}
export const approveCancelVacationRequest = async (
  vacationRequestId,
  vacationRangeId
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.put(
      `${API_VACATION}/approveCancelVacationRequest/${vacationRequestId}/${vacationRangeId}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getLastApprovedVacationRangeByVacationId = async (vacationId) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_VACATION}/getLastApprovedVacationRangeByVacationId/${vacationId}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

/** @type {import("./vacation.service.types")["getTeamMemberDisabledDaysInRange"]} */
export const getTeamMemberDisabledDaysInRange = async (startDate, endDate) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(
      `${API_VACATION}/getTeamMemberDisabledDaysInRange`,
      {
        startDate,
        endDate,
      }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getTeamMemberDisabledDaysInRangeExcludeVacationID = async (
  startDate,
  endDate,
  vacationId
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(
      `${API_VACATION}/getTeamMemberDisabledDaysInRangeExcludeVacationID`,
      {
        startDate,
        endDate,
        vacationId,
      }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const createVacationRequest = async (
  vacationRequest,
  selectedPeriod
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(`${API_VACATION}/createVacationRequest`, {
      startDate: vacationRequest.requestDates[0],
      endDate: vacationRequest.requestDates[1],
      bucketDays: vacationRequest.bucketDays,
      plusDays: vacationRequest.plusDays,
      accordedDays: vacationRequest.accordedDays,
      additionalDays: vacationRequest.additionalDays,
      motive: vacationRequest.motive,
      periodStartDate: selectedPeriod[0],
      periodEndDate: selectedPeriod[1],
    })
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const updateVacationRequest = async (
  vacationId,
  typeOfRequest,
  vacationRequest,
  selectedPeriod
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.put(`${API_VACATION}/updateVacationRequest`, {
      vacationId,
      typeOfRequest,
      startDate: vacationRequest.requestDates[0],
      endDate: vacationRequest.requestDates[1],
      bucketDays: vacationRequest.bucketDays,
      plusDays: vacationRequest.plusDays,
      accordedDays: vacationRequest.accordedDays,
      additionalDays: vacationRequest.additionalDays,
      motive: vacationRequest.motive,
      changeMotive: vacationRequest.changeMotive || null,
      periodStartDate: selectedPeriod[0],
      periodEndDate: selectedPeriod[1],
    })
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const cancelVacationRequest = async (vacationId) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.put(`${API_VACATION}/cancelVacationRequest`, {
      vacationId,
    })
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const requestApprovedVacationCancelation = async (
  vacationId,
  vacationRangeId,
  cancelationMotive
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.put(
      `${API_VACATION}/requestApprovedVacationCancelation`,
      {
        vacationId,
        vacationRangeId,
        cancelationMotive,
      }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getTeamMemberHolidaysOnDateRange = async (startDate, endDate) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(
      `${API_VACATION}/getTeamMemberHolidaysOnDateRange`,
      {
        startDate,
        endDate,
      }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getAllTypeDayOffHolidaySchemaRules = async () => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(`${API_VACATION}/getAllTypeDayOffHolidaySchemaRules`)
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getTeamMemberPlusDaysResume = async (
  periodStartDate,
  periodEndDate,
  monthStartDate,
  monthEndDate
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(`${API_VACATION}/getTeamMemberPlusDaysResume`, {
      periodStartDate,
      periodEndDate,
      monthStartDate,
      monthEndDate,
    })
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getTeamMemberPlusDaysResumeExcludeVacationID = async (
  periodStartDate,
  periodEndDate,
  monthStartDate,
  monthEndDate,
  vacationId,
  vacationStartDate
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(
      `${API_VACATION}/getTeamMemberPlusDaysResumeExcludeVacationID`,
      {
        periodStartDate,
        periodEndDate,
        monthStartDate,
        monthEndDate,
        vacationId,
        vacationStartDate,
      }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getTeamMemberBucketDaysResumeById = async (
  teamMemberId,
  workAnniversary,
  periodStartDate,
  periodEndDate
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_VACATION}/getTeamMemberBucketDaysResumeById`,
      {
        teamMemberId,
        workAnniversary,
        periodStartDate,
        periodEndDate,
      }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getTeamMembersVacationReport = async (teamMemberId) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(`${API_VACATION}/getTeamMembersVacationReport`)
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

/** @type {import("./vacation.service.types")["getTeamMemberVacationHistory"]} */
export const getTeamMemberVacationHistory = async (teamMemberId) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }
  let result
  try {
    result = await api.get(
      `${API_VACATION}/getTeamMemberVacationHistory/${teamMemberId}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getTeamMemberDaysRequested = async (
  filters = { startDate: null, endDate: null }
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(
      `${API_VACATION}/getTeamMemberDaysRequested`,
      filters
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getTeamMemberAditionalDaysTable = async (
  startDate,
  endDate,
  teamMemberId
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(
      `${API_VACATION}/getTeamMemberAditionalDaysTable `,
      {
        startDate,
        endDate,
        teamMemberId,
      }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const createAdditionalDaysPackage = async (data) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result

  try {
    result = await api.post(`${API_VACATION}/createAdditionalDaysPackage`, data)
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const updateAdditionalDaysPackage = async (data) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result

  try {
    result = await api.put(`${API_VACATION}/updateAdditionalDaysPackage`, data)
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const deleteAdditionalDaysPackage = async (id) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result

  try {
    result = await api.delete(`${API_VACATION}/deleteAdditionalDaysPackage`, {
      id,
    })
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}
